<template>
    <div class="score-slider-container">
        <!-- 进度条 -->
        <div class="progress-bar">
            <div v-for="(seg, index) in segments" :key="index" class="segment" :style="{
                width: `${seg.width}%`,
                backgroundColor: seg.color,
                left: `${seg.left}%`
            }"></div>

            <!-- 滑块 -->
            <div class="slider-dot" :style="{ left: `${(value / max) * 100}%` }"></div>
        </div>
        <!-- 刻度标签 -->
        <div class="ticks">
            <span v-for="(seg, index) in segments" :key="index" class="tick">
                {{ seg.label }}
            </span>
        </div>
        <!-- 中央数值显示 -->
        <div class="value-display">{{ value }}</div>
    </div>
</template>
<script>
export default {
  name: 'ScoreSlider',
  props: {
    value: {
      type: Number,
      required: true
    },
    segments: {
      type: Array,
      required: true
    },
    max: {
      type: Number,
      default: 100
    }
  },
  computed: {
    // 计算每个区间的宽度和位置
    computedSegments() {
      const result = [];
      let left = 0;
      this.segments.forEach((seg, index) => {
        const width = ((seg.end - seg.start) / this.max) * 100;
        result.push({
          ...seg,
          width,
          left: left
        });
        left += width;
      });
      return result;
    }
  },
  mounted() {
    // 初始化时确保数据正确
    this.$nextTick(() => {
      // 可选：动画效果
    });
  }
};
</script>
<style scoped>
.score-slider-container {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  text-align: center;
}

.progress-bar {
  position: relative;
  height: 16px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 8px;
  background: linear-gradient(to right, #FFB3C1 0%, #B3E5FC 60%, #81D4FA 100%);
}

.segment {
  position: absolute;
  top: 0;
  bottom: 0;
  border-radius: 8px;
  z-index: 1;
}

.slider-dot {
  position: absolute;
  width: 12px;
  height: 12px;
  top: 0px;
  left: 0;
  background: white;
  border: 2px solid #333;
  border-radius: 50%;
  transform: translateX(-50%);
  z-index: 2;
  box-shadow: 0 0 4px rgba(0,0,0,0.2);
}

.ticks {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #666;
  margin-bottom: 12px;
}

.value-display {
  font-size: 18px;
  font-weight: 500;
  color: #333;
}
</style>